import * as yup from "yup";
import { useFormik } from "formik";
import React from "react";

import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, OutlinedInput, Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

import Title from "../../../common/Title";

import useAxios from "../../../../hooks/useAxios";
import { __queryUsagePWG } from "../../../../api/sim";

const QueryUsageForm = () => {
  const [response, call, loading] = useAxios({
    ...__queryUsagePWG,
  });

  const formik = useFormik({
    initialValues: { mdn: "", esn: "" },
    validationSchema: yup.object({
      mdn: yup
        .string("mdn")
        .min(10, "Should be exactly 10 digits long")
        .max(10, "Should be exactly 10 digits long")
        .required(),
      esn: yup.string("esn").optional(),
    }),
    onSubmit: (values) => {
      call({
        params: {
          mdn: values.mdn,
          esn: values.esn || undefined,
        },
      });
    },
    validateOnChange: true,
  });

  return (
    <>
      <Box
        sx={{ width: "100%" }}
        display="flex"
        alignItems="center"
        flexDirection="column"
      >
        <Title
          variant="h5"
          content="Query Usage (PWG)"
          sx={{ mb: 3 }}
          gutterBottom
        />
        <Grid
          sx={{ flexGrow: 1, width: "100%" }}
          container
          spacing={2}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs sx={{ minWidth: 400 }}>
            <FormControl
              error={
                formik.touched.mdn && Boolean(formik.errors.mdn)
                  ? true
                  : false
              }
              sx={{ width: "100%" }}
            >
              <InputLabel htmlFor="mdn">MDN</InputLabel>
              <OutlinedInput
                name="mdn"
                label="MDN"
                id="mdn"
                value={formik.values.mdn}
                onChange={formik.handleChange}
              />
              {formik.touched.mdn && Boolean(formik.errors.mdn) ? (
                <FormHelperText id="mdn-error-text">
                  {formik.errors.mdn}
                </FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
          <Grid item xs sx={{ minWidth: 400 }}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel htmlFor="esn">ESN (optional)</InputLabel>
              <OutlinedInput
                name="esn"
                label="ESN (optional)"
                id="esn"
                value={formik.values.esn}
                onChange={formik.handleChange}
              />
            </FormControl>
          </Grid>

          <Grid
            container
            sx={{ mt: 3 }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <LoadingButton
                style={{ marginRight: "5px" }}
                disabled={loading || !formik.values.mdn}
                onClick={() => !loading && formik.submitForm()}
                size="large"
                loading={loading}
                variant="contained"
              >
                {"Query Usage"}
              </LoadingButton>
            </Grid>
          </Grid>

          {response && response.status && (
            <Grid item sx={{ mt: 3, width: "100%" }}>
              <Typography variant="subtitle1">Result</Typography>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  background: "#f5f5f5",
                  padding: "12px",
                  borderRadius: "4px",
                }}
              >
                {JSON.stringify(response.data, null, 2)}
              </pre>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default QueryUsageForm;
